// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._39ft{position:relative;flex-direction:column}._39ft,._2GuU{display:flex}._3pVy,.U6Oo{margin-bottom:.8rem}._3Jri{flex:1;padding:.4em .6em;border:1px solid #373737}._3Jri:focus{outline:1px solid #373737}", ""]);
// Exports
exports.locals = {
	"root": "_39ft",
	"wrapper": "_2GuU",
	"description": "_3pVy",
	"label": "U6Oo",
	"input": "_3Jri"
};
module.exports = exports;
